import { createSlice } from '@reduxjs/toolkit'
import { LocalData } from '../types.ts'

const initialState = {} as LocalData

export const storeSlice = createSlice({
  name: 'localData',
  initialState,
  reducers: {
    addLocal: (state, action) => {
      const { urlname, idColumn, localData } = action.payload
      if (urlname in state) {
        const existingLocal = state[urlname]
        if (existingLocal.idColumn != idColumn) {
          console.error("idColumn shouldn't change")
          return
        }
        const newId = localData[idColumn]
        const newLocalData = [
          ...existingLocal.localData.filter((item) => !item[idColumn] == newId),
          localData,
        ]
        state[urlname].localData = newLocalData
      } else {
        state[urlname] = { idColumn, localData: [localData] }
      }
    },
  },
})

export const { addLocal } = storeSlice.actions

export default storeSlice.reducer
